import { render, staticRenderFns } from "./Payres.vue?vue&type=template&id=18fcb177&scoped=true"
import script from "./Payres.vue?vue&type=script&lang=js"
export * from "./Payres.vue?vue&type=script&lang=js"
import style0 from "./Payres.vue?vue&type=style&index=0&id=18fcb177&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fcb177",
  null
  
)

export default component.exports